import { CustomLink } from "Shared/CustomLink";
import { MenuItem, Stack, Typography, useTheme } from "@mui/material";
import type { DropdownMenuItem } from "./DropdownMenu";

type DropdownMenuLinkItemProps = {
  item: DropdownMenuItem;
  onClick: () => void;
};

export const DropdownMenuLinkItem = ({
  item,
  onClick,
}: DropdownMenuLinkItemProps) => {
  const { customFontWeight, customSpacing, radius } = useTheme();

  return item.href ? (
    <MenuItem
      onClick={onClick}
      component={CustomLink}
      href={item.href}
      disableRipple
      sx={{
        py: customSpacing.md,
        mx: customSpacing.md,
        borderRadius: radius.md,
        height: 40,
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          gap: customSpacing.sm,
        }}
      >
        {item.icon}
        <Typography variant="body2" fontWeight={customFontWeight.medium}>
          {item.label}
        </Typography>
      </Stack>
    </MenuItem>
  ) : (
    <MenuItem
      onClick={onClick}
      disableRipple
      sx={{
        py: customSpacing.md,
        mx: customSpacing.md,
        borderRadius: radius.md,
        height: 40,
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          gap: customSpacing.sm,
        }}
      >
        {item.icon}
        <Typography variant="body2" fontWeight={customFontWeight.medium}>
          {item.label}
        </Typography>
      </Stack>
    </MenuItem>
  );
};
